import { writable } from 'svelte/store';
import {isLoggedIn, userId} from '../components/stores/UserStore';

export const sessionReady = writable(false);

export async function restoreSession() {
    fetch('https://www.deckblox.app/rest/session', {
        method: 'GET'
    })
    .then((response) =>  response.json())
    .then((data) => {
        if (data.message) {
            console.log('Error: ', data.message);
            isLoggedIn.set(false);
        } else {
            if(data.userid) {
                console.log('Logged in user: ', data.userid);
                userId.set(data.userid);
                isLoggedIn.set(true);
            } else {
                isLoggedIn.set(false);
            }
        }
    })
    .catch((error) => {
        console.error('Error Session:', error);
        isLoggedIn.set(false);
    });

	sessionReady.set(true);  
}